import { PurchaseRequestProductDetails, Urgency, UrgencyMapping } from "@/types";
import { currentISODate, getTimeAgo } from "@/utility";
import classNames from "classnames";
import { ReactNode } from "react";

interface PurchaseRequestLeadCardProps {
    lead: PurchaseRequestProductDetails;
    children: ReactNode
}

const PurchaseRequestLeadCard: React.FC<PurchaseRequestLeadCardProps> = ({ lead, children }) => {
    return (
        <div className="card kg-bg-light shadow-sm h-100">
            <div className="card-header bg-transparent border-0 h-100">
                <div className="d-flex gap-2 justify-content-between">
                    <div className="flex-grow-1">
                        <p className="fs-7 text-bold">{lead?.createdUserName || '-'}</p>
                        <p className="fs-8 kg-light-dark">
                            {lead.address || '-'}
                        </p>
                    </div>
                    <div>
                        <span className="fs-8 flex-shrink-0 text-nowrap">{getTimeAgo(lead?.createdDateTime || currentISODate())}</span>
                    </div>
                </div>
            </div>
            <div className="card-body border border-1 kg-bg-white rounded-top-4 rounded-bottom-2">
                <div className="d-flex gap-2 justify-content-between">
                    <div>
                        <p className="text-wrap text-bold">{lead.parentCategoryName || '-'}</p>
                        <p className="text-wrap fs-7">{lead.productName || "-"}</p>
                    </div>
                    <div>
                        <small className={classNames("badge rounded-pill fs-8", UrgencyMapping[lead.urgency]?.color ?? "text-bg-success")}>{UrgencyMapping[lead.urgency]?.label || '-'}</small>
                        <br/>
                        { lead && lead.status== 'Verified' ?
                                    <small className={ ("rounded-pill text-end text-green ms-5 pul-right")}>{lead?.status || '-'}</small>
                                    : <></>
                        }
                    </div>
                    
                </div>
                <div className="row row-col-2 g-4 mt-2">
                    <div className="col">
                        <div className="kg-bg-light rounded-3 p-2">
                            <p className="fs-8">Qty</p>
                            <p className="fs-7 kg-dark">{lead.quantity} {lead.unit || '-'}</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="kg-bg-light rounded-3 p-2">
                            <p className="fs-8">Approx Order Value</p>
                            <p className="fs-7 kg-dark">₹{lead.orderValue || '-'}</p>
                        </div>
                    </div>
                </div>
                <div className="mt-3">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default PurchaseRequestLeadCard;